import _extends from "@babel/runtime/helpers/extends";
import { Card, Grid } from 'core/components';
import React from 'react';
function PlanCardContainer({
  children,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    p: 2
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    gridTemplateColumns: "2fr 1fr",
    gridTemplateRows: "1fr"
  }, children));
}
export default PlanCardContainer;